import React from 'react';
import { SendTemplateModal } from '../SendTemplate';
import { HandlePaymentRequest, LegalDocsConfigurations } from '../../types';
import { BiData } from '../../biEvents';
import { useTemplatesData } from '../../hooks';
import { RequestToUploadModal } from '../RequestToUploadModal';

export interface InitialInteractionActionModalProps {
    configurations?: LegalDocsConfigurations;
    totalTemplates: number;
    activeTemplates: number;
    sellerName: string;
    sellerId: number;
    handlePayment: HandlePaymentRequest;
    isOpen?: boolean;
    closeModal: () => void;
    biData: BiData;
}

export const InitialInteractionActionModal = ({
    configurations,
    activeTemplates,
    totalTemplates,
    sellerName,
    sellerId,
    handlePayment,
    isOpen,
    closeModal,
    biData,
}: InitialInteractionActionModalProps) => {
    const { sellerDataQuery } = useTemplatesData({ sellerId });
    if (!configurations) {
        return null;
    }

    if (totalTemplates) {
        return (
            <SendTemplateModal
                configurations={configurations}
                sellerName={sellerName}
                sellerId={sellerId}
                onSend={() => sellerDataQuery.refetch()}
                isDisabled={!activeTemplates}
                handlePayment={handlePayment}
                isOpen={isOpen}
                onClose={closeModal}
                biData={biData}
            />
        );
    }

    return <RequestToUploadModal biData={biData} isOpen={isOpen} onClose={closeModal} />;
};
